import styled from 'styled-components';
import { Type } from '../types'

export const SectionCongrats = styled.section`
color: ${(props: Type) => props.theme.congrats.textColor};
`
